<template>
  <v-container>
    <v-card-title class="d-flex justify-space-between">
      <div class="d-flex align-center">
        <h3 class="mr-10">{{ supplierCorpName }}</h3>
        <h4 class="primary--text text-subtitle-1" role="complementary">
          <slot name="available-text" />
        </h4>
      </div>
      <div class="d-flex align-center ml-auto">
        <div class="text-subtitle-1 mr-10 text-right">
          <slot name="modification-text" />
        </div>
        <v-btn
          @click="$emit('validate')"
          color="primary"
          :disabled="validationDisabled"
          role="button"
          :loading="loading"
        >
          {{ $t('page.selection.validate') }}
        </v-btn>
      </div>
    </v-card-title>
    <v-divider class="my-2" />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'PurchaseConditionSelectionHeader',
  props: {
    supplierCorpName: {
      type: String,
      required: true
    },
    hasModification: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    validationDisabled(): boolean {
      return !this.hasModification || this.loading;
    }
  }
});
</script>
